import React, { ComponentProps } from "react";

import { Props as RadioButtonProps } from "@storeblocks/radio";
import { useTexts } from "Components/TextContext";
import { OptionLabel } from "Components/TextContext/commonComponentEnums";
import { useButtonTexts } from "Store/texts/hooks";
import { RadioButton } from "./RadioButton";

export interface Option {
  id: string;
  label: string;
  value: boolean;
}

type BaseProps = Omit<
  ComponentProps<typeof RadioButton>,
  "options" | "numeric" | "onChange"
> & {
  onChange?: RadioButtonProps["onChange"];
};
type NormalProps = { options: Option[] };
type LabeledProps = {
  yesLabel?: string;
  noLabel?: string;
};

type Props = (BaseProps & NormalProps) | (BaseProps & LabeledProps);

export const RadioButtonTrueFalse = (props: Props): React.ReactElement => {
  const [{ readMore, readLess }, lang] = useButtonTexts();

  const { getText } = useTexts();

  const options: Array<Option> =
    "options" in props
      ? props.options
      : [
          {
            id: `${props.name}-yes`,
            value: true,
            label: props.yesLabel ?? getText(OptionLabel.BOOLEAN_YES),
          },
          {
            id: `${props.name}-no`,
            value: false,
            label: props.noLabel ?? getText(OptionLabel.BOOLEAN_NO),
          },
        ];

  return (
    <RadioButton
      {...props}
      options={options.map((option) => ({
        ...option,
        value: String(option.value),
        hintProps: {
          maxLines: 4,
          readLessLabel: `${readLess[lang]}`,
          readMoreLabel: `${readMore[lang]}`,
        },
      }))}
    />
  );
};
